const APIPath = 'https://apiprospect.squareboard.cloud';

export { APIPath };
